import SubscriptionRepository from '@/business/modules/subscription/subscription.repository';

const CACHE_TTL_MS = 60_000;
let cachedAt = 0;
let cachedContext: any = null;
let pendingRequest: Promise<any> | null = null;

const unwrap = (payload: any) => payload?.data?.data ?? payload?.data ?? payload ?? {};

export const getSubscriptionContext = async (force = false) => {
	if (!force && cachedContext && Date.now() - cachedAt < CACHE_TTL_MS) return cachedContext;
	if (pendingRequest) return pendingRequest;

	pendingRequest = SubscriptionRepository.getInstance()
		.getCurrent()
		.then((response: any) => {
			cachedContext = unwrap(response);
			cachedAt = Date.now();
			return cachedContext;
		})
		.finally(() => {
			pendingRequest = null;
		});

	return pendingRequest;
};

export const hasSubscriptionEntitlement = (context: any, key: string) => String(context?.entitlements?.[key] || '').toLowerCase() === 'true';

export const clearSubscriptionContext = () => {
	cachedAt = 0;
	cachedContext = null;
};
